import { curry } from 'lodash';

const patterns = {
    //         dd     [./]      mm  [./] yyyy
    date: /[0-9]{2}([/|.])[0-9]{2}\1[0-9]{4}/,
    email: /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))/i,
    name: /[a-zа-я-]+\s+(?:[a-zа-я]\.){1,2}/i
};

const get = curry((pattern, string) => {
    return (pattern.exec(string || '') || [''])[0];
});

const remove = curry((pattern, string) => {
    return (string || '').replace(pattern, '').trim();
});

const match = curry((pattern, string, detailed = false) => {
    var results = [], match;
    if (!pattern.global) {
        var flags = pattern.multiline ? 'gm' : 'g';
        if (pattern.ignoreCase) {
            flags += 'i';
        }
        pattern = new RegExp(pattern.source, flags);
    }

    while (match) {
        results.push(detailed ? {
            firstIndex: pattern.lastIndex - match[0].length,
            lastIndex: pattern.lastIndex,
            result: match[0]
        } : match[0]);

        match = pattern.exec(string || '');
    }

    return results;
});

const Parser = {
    date: {
        get:    get(patterns.date),
        remove: remove(patterns.date),
        match:  match(patterns.date)
    },

    email: {
        get:    get(patterns.email),
        remove: remove(patterns.email)
    },

    phone: {
        href: (string = '') => {
            return (string.match(/\d+/g) || []).join('');
        }
    },

    name: {
        get: get(patterns.name)
    }
};

export default Parser;
